module.exports = __webpack_public_path__ + "img/deliver-img-4-1.c94fe57f.png";